import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ExamSummary, Intake, Patient, ScheduleResponse } from '../models';
import { Api, Session } from '../services/index';

@Component({
  selector: 'app-exam-expect',
  templateUrl: './exam-what-to-expect.html'
})

export class ExamWhatToExpect implements OnInit {
  @ViewChild('myModal') _modalMsg: ElementRef;

  patientId: number;

  constructor(private api: Api, 
              private route: ActivatedRoute,
              private router: Router,
              private session: Session) {
    this.patientId = this.route.snapshot.params['patientId'] || ''; 
  }

  ngOnInit() {
  }
  
  continue() {
    this.router.navigate(['/exam-appointment/' + this.patientId]);
  }
  
  close() {
    (<any>$(this._modalMsg.nativeElement)).modal('hide');
  }
}
